module.exports = __webpack_public_path__ + "media/images/LenovoPremierSupport-78e20aa5586f33e6b47e0d24ed2cf937.jpg";